import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76c73937"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "view",
  "data-view": "",
  id: "landingPage"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<span class=\"mosaic mosaic-top-right\" data-v-76c73937></span><span class=\"mosaic mosaic-top-left\" data-v-76c73937></span><span class=\"mosaic mosaic-center-right\" data-v-76c73937></span><span class=\"mosaic mosaic-center-left\" data-v-76c73937></span><span class=\"mosaic mosaic-bottom-right\" data-v-76c73937></span><span class=\"mosaic mosaic-bottom-left\" data-v-76c73937></span>", 6)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Call = _resolveComponent("Call")!
  const _component_DivisorView = _resolveComponent("DivisorView")!
  const _component_AboutView = _resolveComponent("AboutView")!
  const _component_HighLightsView = _resolveComponent("HighLightsView")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Call),
    _createVNode(_component_DivisorView),
    _createVNode(_component_AboutView),
    _createVNode(_component_DivisorView),
    _createVNode(_component_HighLightsView),
    _createVNode(_component_DivisorView),
    _hoisted_2,
    _createVNode(_component_Footer)
  ]))
}